import { React, useState  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { UserForm } from 'components/UserManagement/UserForm/UserForm';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';
export function NewUser() {
    const { t } = useTranslation();
    const [userFormData, setUserFormData] = useState({
    username: '',
    name: '',
    surnames: '',
    password: '',
    controlCentreId: 0,
    role: '',
    isActive: true
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
      setUserFormData({
          ...userFormData,
      [name]: value
    });
  };

    const handleSubmit = async () => {
      const response = await api.createUser(userFormData);
    if (response.status === 200) {
      navigate('/userManagement');      
    } else {
        setError(t('usError'));
    }
  };
  
  return (
      <Container>
              <h2 className="mt-4">{t('usNew')}</h2>
        <UserForm
          userFormData={userFormData}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          error={error}
          setError={setError}
          isEditing={false}
        />
      </Container>
  );
}